var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlarmDelete = function SvgIconAlarmDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.42 3.742a.75.75 0 0 1 .066.984l-.067.076-7.746 7.747a.75.75 0 0 1-1.127-.984l.067-.077 7.746-7.746a.75.75 0 0 1 1.06 0Z",
    fill: "#57595E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.613 3.742a.75.75 0 0 1 .984-.067l.076.067 7.746 7.746a.75.75 0 0 1-.983 1.128l-.077-.067-7.746-7.746a.75.75 0 0 1 0-1.061Z",
    fill: "#57595E"
  })));
};
export default SvgIconAlarmDelete;